import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "../App";
import axios from "axios";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          navigate("/", { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const userData = response.data;
        setUser(userData);

        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);

        // Redirect based on user status and roles
        const roles = userData.roles || [];
        const approval = userData.approval_status;
        
        if (approval === 'pending' || approval === 'denied') {
          navigate("/dashboard", { replace: true }); // ProtectedRoute will show PendingApproval
        } else if (roles.includes('deudor') && !roles.includes('normal') && !userData.is_admin) {
          navigate("/my-loans", { replace: true });
        } else if (roles.includes('inversionista') && !roles.includes('normal') && !userData.is_admin) {
          navigate("/my-portfolio", { replace: true });
        } else if (userData.has_completed_survey) {
          navigate("/dashboard", { replace: true, state: { user: userData } });
        } else {
          navigate("/survey", { replace: true, state: { user: userData } });
        }
      } catch (error) {
        const detail = error?.response?.data?.detail || error?.message || 'Error desconocido';
        const status = error?.response?.status || 0;
        console.error("Auth exchange failed:", { status, detail, url: `${API}/auth/session` });
        // Redirect to finance login page with error indicator and detail
        navigate(`/finance?auth_error=1&detail=${encodeURIComponent(detail)}&status=${status}`, { replace: true });
      }
    };

    processAuth();
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-muted-foreground">Autenticando...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
